import { Card, CardBody, Container, Row } from 'reactstrap'
import { BillingDetails } from '../../../../Utils/Constants'
import CheckoutForm from './CheckoutForm/CheckoutForm'
import ProductCheckout from './ProductCheckout/ProductCheckout'
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'

const CheckoutContainer = () => {
  return (
    <Container fluid className='checkout'>
        <Card>
          <CommonCardHeader title={BillingDetails} />
          <CardBody>
            <Row>
              <CheckoutForm />
              <ProductCheckout />
            </Row>
          </CardBody>
        </Card>
    </Container>
  )
}

export default CheckoutContainer